import React, { useState, useEffect } from 'react'
import { Link, useParams, useHistory } from 'react-router-dom'
import NormalLayoutContainer from '../shared/NormalLayoutContainer'
import { PageTitle } from '../../components/page-title'
import { Spinner } from '../shared/Spinner'
import notify from '../../utilities/notify'
import AssetDetailsDisplay from '../../components/asset-details-display'
import ResourceActivitiesDisplay from '../hauler/resources/_id/index/components/ResourceActivitiesDisplay'
import useQuery from '../../hooks/useQuery'
import QUERY_KEYS from '../../graphql/queryKeys'
import activitiesQuery from '../../graphql/queries/activities'
import assetQuery from '../../graphql/queries/assetQuery'
import useMutation from '../../hooks/useMutation'
import deleteResourceMutation from '../../graphql/mutations/deleteResource'
import { captureErrorAndNotify } from '../../utilities/errorHandlers'

const pageSize = 25

export default function AssetDetailsPage () {
  const history = useHistory()
  const { id } = useParams()
  const [fakeCount, setFakeCount] = useState(null)
  const [pager, setPager] = useState(null)

  const {
    data: { activities: assetActivities },
    isFetching: isLoadingResourceActivities
  } = useQuery(
    [QUERY_KEYS.activities, 'RESOURCE', id, '', pager],
    activitiesQuery,
    {
      onError (error) {
        captureErrorAndNotify(error, 'Error fetching ticket activities')
      },
      placeholderData: { activities: {} }
    }
  )

  const confirmDestoryResource = () => {
    deleteResource({ id })
  }

  useEffect(function toggleFakePagination () {
    if (assetActivities?.totalCount === undefined || fakeCount !== null) return
    setFakeCount({ start: 1, end: Math.min(pageSize, assetActivities.totalCount) })
  }, [assetActivities, fakeCount])

  function onActivitiesPageRequest (direction, cursor) {
    if (!fakeCount) return
    setPager({ cursor, direction, pageSize })
    if (direction === 'before') {
      setFakeCount(prevFakeCount => ({ start: prevFakeCount.start - pageSize, end: prevFakeCount.end - pageSize }))
    }
    if (direction === 'after') {
      setFakeCount(prevFakeCount => ({ start: prevFakeCount.start + pageSize, end: prevFakeCount.end + pageSize }))
    }
  }

  const { data: asset, isFetching: assetFetching } = useQuery([
    QUERY_KEYS.asset,
    id
  ],
  assetQuery,
  {
    onError: (error) => captureErrorAndNotify(error, 'Error retrieving asset')
  })

  const { mutate: deleteResource, isLoading: deleteAssetLoading } = useMutation(deleteResourceMutation, {
    onSuccess () {
      history.goBack()
      notify('success', 'Asset destroyed successfully!')
    },
    onError (error) {
      captureErrorAndNotify(error, `Error destroying asset ${asset?.asset?.uid}`)
    }
  })

  const isFetching = assetFetching || deleteAssetLoading

  return (
    <div>
      <NormalLayoutContainer showBackLink>
        <div className='container-fluid'>
          <PageTitle title={`Asset - ${asset?.asset?.uid}`}>
            <Link
              className='btn btn-lg btn-primary-dk pull-right push-down-super-small'
              to={`/hauler/resources/${id}/edit`}>
              <span>Edit Asset</span>
              <i className='material-icons'>mode_edit</i>
            </Link>

          </PageTitle>
          <br />

          <div className='row'>
            <Spinner isFetching={isFetching}>
              <div>
                <AssetDetailsDisplay resource={asset?.asset} />
              </div>
            </Spinner>
          </div>

          <Spinner isFetching={isLoadingResourceActivities}>
            <ResourceActivitiesDisplay
              activities={assetActivities}
              onPageRequest={onActivitiesPageRequest}
              fakeCount={fakeCount}
            />
          </Spinner>

        </div>
        {/* Destroy Resource Button */}
        <button
          className='btn btn-link center-block'
          onClick={() => {
            // eslint-disable-next-line no-restricted-globals
            const result = confirm(
              'THIS CANNOT BE UNDONE! Deleting an asset will remove any record ' +
                    'that it existed, including its location at a job site.')
            if (result) {
              confirmDestoryResource()
            }
          }}>
          <span className='pull-left'>Destroy Asset</span>
          <i className='material-icons pull-right thumbster-button-icon'>delete</i>
        </button>
        <br />
      </NormalLayoutContainer>
    </div>
  )
}
